import React from "react";

const ProjectPage = () => {
  const videoId = "Vrsd0wnOH_Q";

  const credits = [
    { role: "Director / Cinematographer / Editor", name: "Sylvester P. Lukasiewicz, SPL Films LLC" },
    { role: "Sound Mixer", name: "Robert Kahn, Mixology Post LLC" },
    { role: "Color Correction & Grading", name: "Luis Otero, CSI, Digital Emulsion LLC" },
  ];

  return (
    <div className="max-w-5xl mx-auto px-6 sm:px-8 py-12 md:py-16 text-white">
      
      {/* Hero Header & Video */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-12">
        <div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight mb-4">
            Back to One - Return to Ground Zero
          </h1>
          <div className="text-base sm:text-lg font-medium tracking-wide text-gray-300 space-y-1">
            <p>Documentary Short</p>
            <p>United States | 26 minutes</p>
            <p>English | English subtitles</p>
          </div>
        </div>

        <div className="relative pb-[56.25%] h-0 shadow-2xl rounded-lg overflow-hidden border border-gray-700 bg-black">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title="Back to One"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Broadcast Schedule Card */}
      <section className="bg-gray-900/60 border border-gray-700/80 rounded-xl p-6 sm:p-8 mb-12 shadow-xl backdrop-blur-sm">
        <h2 className="text-lg sm:text-xl font-bold tracking-wider text-sky-400 uppercase mb-6 flex items-center gap-3">
          <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse"></span>
          Upcoming Broadcast Schedule
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-base text-gray-200">
          {/* Schedule Listings */}
          <div className="space-y-4 font-normal">
            <div className="space-y-1">
              <p>September 6, 2026 at 8:00 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">NYC Life</span></p>
              <p>September 7, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
              <p>September 8, 2026 at 7:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">NYC Life</span></p>
              <p>September 8, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
              <p>September 9, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
              <p>September 10, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
            </div>

            <div className="space-y-1 pt-2 border-t border-gray-800/80">
              <p>September 11, 2026 at 8:00 AM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">NYC Life</span></p>
              <p>September 11, 2026 at 14:15 CEST <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24 BiS</span></p>
              <p>September 11, 2026 at 14:15 CEST <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24+</span></p>
              <p>September 11, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
              <p>September 11, 2026 at 21:00 CEST <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24 BiS</span></p>
              <p>September 11, 2026 at 21:00 CEST <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">TVN24+</span></p>
            </div>

            <div className="space-y-1 pt-2 border-t border-gray-800/80">
              <p>September 12, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
              <p>September 13, 2026 at 8:30 PM <span className="font-semibold text-white bg-gray-800 px-2 py-0.5 rounded text-sm ml-1">CUNY TV</span></p>
            </div>
          </div>

          {/* Where to Watch Guide */}
          <div className="text-sm text-gray-300 space-y-3 bg-black/40 p-5 rounded-lg border border-gray-800 flex flex-col justify-center">
            <h3 className="text-xs uppercase tracking-wider font-bold text-gray-400 mb-1">Where to Watch</h3>
            <p>
              <strong className="text-white font-semibold">NYC Life</strong> (WNYE-TV): Available in NYC via cable (Spectrum/Optimum Ch. 74, RCN Ch. 81, Verizon Fios Ch. 24) and over-the-air UHF Ch. 25.2.
            </p>
            <p>
              <strong className="text-white font-semibold">CUNY TV</strong>: Available in NYC via cable (Spectrum/Optimum Ch. 75, RCN Ch. 77, Verizon Fios Ch. 30) and over-the-air UHF Ch. 25.3.
            </p>
            <p>
              <strong className="text-white font-semibold">TVN24 BiS</strong>: Available across Poland via cable and satellite.
            </p>
            <p>
              <strong className="text-white font-semibold">TVN24+</strong>: Available across Poland via application subscription.
            </p>
          </div>
        </div>
      </section>

      <hr className="border-gray-600 border-t my-10" />

      {/* Synopsis */}
      <section className="space-y-6 text-lg text-gray-200">
        <p className="font-bold text-xl leading-relaxed text-white">
          An intimate documentary following a former Windows on the World employee and 9/11 survivor as he returns to the rebuilt World Trade Center site for the first time in 24 years, honoring lost colleagues and reflecting on memory, resilience, and healing. 
        </p>
        <p>
          In this moving documentary, former Windows on the World banquet captain and manager Stephen Lindsey reflects on the events of September 11, 2001, and the lasting impact of that day on his life and community. Through personal memories and a return to the rebuilt World Trade Center site, Stephen recounts witnessing the attacks, coping with the loss of colleagues and friends, and finding ways to honor those who never came home.
        </p>
        <p>
          As he walks through the 9/11 Memorial, The Oculus, and the Winter Garden, Stephen shares stories of camaraderie, everyday joys, and small acts of kindness that defined the close-knit community he once knew. Juxtaposing the beauty of the reconstructed site with the profound absence left behind, the film explores themes of grief, memory, resilience, and healing. Both a deeply personal elegy and a tribute to collective remembrance, it celebrates the enduring human spirit in the face of unimaginable loss.
        </p>
      </section>

      <hr className="border-gray-600 border-t my-10" />

      {/* Credits */}
      <section>
        <h2 className="text-2xl font-extrabold tracking-widest mb-8 text-white">CREDITS</h2>
        <div className="space-y-6">
          {credits.map((credit, index) => (
            <div key={index}>
              <h3 className="font-bold text-lg text-white">{credit.role}</h3>
              <p className="text-base text-gray-300">{credit.name}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export { ProjectPage };